import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import TwoFAService from "../../services/twoFAService";
import Button from "../../components/UI/Buttons/Button";
import QRCodeGenerator from "../ClinicContainer/QrCode";
import { Modal } from "react-bootstrap";
import { OK } from "../../utils/constant";
import FormInputs from "../../components/UI/FormInputs";
import WithRoutify from "../../hoc/WithRoutify";


const TwoFAVerify = (props) => {
    const [selectedMethod, setSelectedMethod] = useState("");
    const [isQrCodeModal, setQrCodeModal] = useState(false);
    // const { props.userId } = useParams();
    const [isError,setIsError]=useState("")
    const [verifyData,setVerifyData]=useState([])
    const [loading, setLoading] = useState(false);
    const [qrCode, setQrCode] = useState(null);
    const [secretKey, setSecretKey] = useState(null);
    const [showVerification, setShowVerification] = useState(false);
    const [verificationCode, setVerificationCode] = useState("");
    const [enabledMethods, setEnabledMethods] = useState([]); // State to store enabled 2FA methods
    const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const [currentToggleId, setCurrentToggleId] = useState(null); // Store the ID of the method being toggled
    const [currentToggleState, setCurrentToggleState] = useState(false); // Store the current state of the method
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState(""); 
    const [showDeleteModel, setShowDeleteModal] = useState(false);
    const [showConfirmDeleteModal, setConfirmDeleteModal] = useState(false);
    const [verificationCodeErr, setVerificationCodeError] = useState("");
    const [timer, setTimer] = useState(120);  // Timer starts at 120 seconds
    const [isTimerActive, setIsTimerActive] = useState(false);  // Flag to control timer
    const [canResend, setCanResend] = useState(false);  // Control if "Resend Code" can be shown
    const [resendCount, setResendCount] = useState(() => {
        const storedCount = sessionStorage.getItem("resendCount");
        return storedCount ? parseInt(storedCount, 10) : 0;
    });
    useEffect(() => {
        let interval;
        if (isTimerActive && timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        }
        if (timer === 0) {
            clearInterval(interval);
            setCanResend(true);
        }

        // Clean up interval if the timer is not active or the component is unmounted
        return () => clearInterval(interval);
    }, [isTimerActive, timer,resendCount]);
    const handlePasswordChange = (e) => {

        setPassword(e.target.value);
    };
    const handleResend = async (event) => {
        // setResendCount((prevCount) => {
        //     const newCount = prevCount + 1;
        //     sessionStorage.setItem("resendCount", newCount); // Save to sessionStorage
        //     return newCount;
        // });
        // if(resendCount >=5){
        //     sessionStorage.clear();
        //     localStorage.clear();
            // await lockUserAccount();
        //     alert('Maximum resend code exceeded Your account is locked. Please contact admin to unlock.');
        //     return;
        // }
        setTimer(120);
        setIsTimerActive(true);
        setCanResend(false);
        await handleSubmit(event);
    };
    const lockUserAccount = async () =>{
        try{
            setLoading(true);
            const payload = {
                user_id: props.userId,
                is_block: true,
            };
            await TwoFAService.lockUserAccount(payload);
        }catch(error){
            console.error('Error locking user account:', error);
            alert("An error occurred. Please try again.");
        }
    };
    const handleConfirm = async () => {
        if (!password) {    
            setPasswordError("Password is required");
            return;
        }else{
        try {
            setLoading(true);
            const payload = {
                user_id: props.userId,
                id: currentToggleId,
                enabled: !currentToggleState, // Toggle the state
                password: password,
                method:selectedMethod,
            };
            const response = await TwoFAService.toggleTwoFA(payload);
            console.log(response);
            if (response && response.code === OK) {
                // Update the enabledMethods state
                setEnabledMethods((prevMethods) =>
                    prevMethods.map((method) =>
                        method.id === currentToggleId
                            ? { ...method, enabled: !currentToggleState }
                            : method
                    )
                );
                setShowModal(false);
                props.Toast.success("sucesss")
                setPassword("")
                fetchEnabledMethods()
            } else {
                setPasswordError('Invalid Password');
                console.log("Failed to toggle 2FA method.");
            }
        } catch (error) {
            console.error("Error toggling 2FA method:", error);
            alert("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    }
    }
    // Fetch enabled 2FA methods when the component mounts
    useEffect(() => {
        
        fetchEnabledMethods();
    }, []);

    const fetchEnabledMethods = async () => {
        try {
            setLoading(true);
            const response = await TwoFAService.getEnabledTwoFAMethods(props.userId);
            if (response && response.data) {
               
                setEnabledMethods(response.data); // Store the list of enabled methods
                const stepData = [
                    {varName:"sms",
                head:"Phone Authenticator",
                para:"Receive a verification code via SMS",
                },
                   {varName:"email",
                head:"Email Authenticator",
                para:"Receive a verification code via Email",
                },
                   {varName:"app",
                head:"App Authenticator",
                para:"Scan a QR code with an authenticator app",
                }
                ]
                const filterData=stepData.filter((val)=>{
                    const match = response.data.find(d => d.method === val.varName )
                    if (match && match.enabled === true) {
                        return false;
                      }
                      
                      return true;
                }
            )   
            console.log("ss",response.data,filterData);
                setVerifyData(filterData)
            }
        } catch (error) {
            console.error("Error fetching enabled 2FA methods:", error);
        } finally {
            setLoading(false);
        }
    };
    const handleMethodSelect = (method) => {
        setSelectedMethod(method);
        setQrCode(null);
        setSecretKey(null);
        setShowVerification(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault()
        setTimer(120);
        setIsTimerActive(true);  // Start the timer when the form is submitted
        setCanResend(false); 
        if (!selectedMethod) return;
        setLoading(true);

        const payload = {
            user_id: props.userId,
            two_factor_method: selectedMethod
        };

        try {
            const response = await TwoFAService.enableTwoFA(payload);
            console.log(response);
            if (response && response.message) {
                alert(response.message);
            }

            // If App Authenticator is selected, show QR code and verification input
            if (selectedMethod === "app") {
                console.log(response.qr_code);
                setQrCode(response.qr_code);
                setSecretKey(response.secret);
            }
            
            setShowVerification(true); // Always show verification input after method selection
        } catch (error) {
            console.error("Error enabling 2FA:", error);
            alert("Failed to submit. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleVerify = async (event) => {
        event.preventDefault();
        if (!verificationCode) return;
        setLoading(true);

        try {
            const response = await TwoFAService.verifyTwoFA({
                user_id: props.userId,
                code: verificationCode,
                two_factor_method: selectedMethod
            });
            console.log("res",response);
            if (response.code===200 && response.data) {
                // alert(response.data.data);
                props.Toast.success(response.data.data)
                setShowVerification(false)
                setSelectedMethod("")
                fetchEnabledMethods()
                setIsTimerActive(false)
                setVerificationCode("")
            }else if(response.code===422){
                setIsError(response.data)
            } else {
                setIsError(response.data.message || "Invalid verification code.");
            }
        } catch (error) {
            console.error("Error verifying 2FA:", error);
            setIsError("Failed to verify. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    const handleToggle = async (id, enabled,method) => {
        setCurrentToggleId(id);
        setCurrentToggleState(enabled);
        setShowModal(true);
        setSelectedMethod(method);
    };
    const cancelToggle = () => {
        setPassword("")
        setShowModal(false); // Close the modal without making changes
    };
    const cancelDeleteToggle =()=>{
        setPassword("")
        setShowDeleteModal(false);
    }
    const handleDelete = async (id,method) => {
        setCurrentToggleId(id);
        setShowDeleteModal(true);
        setSelectedMethod(method);
    };
    const closeDeleteModal = () =>{
        setVerificationCode("")
        setConfirmDeleteModal(false);
    };
    const handleVerificationCode=(e)=>{
        setIsError("")
        const regex = e.target.value.replace(/[^0-9]/g, '');
        console.log("etst", (e.target.value));
        
        if(regex.length <= 6 ){
        setVerificationCode(regex)}
    }

    const handleDeleteConfirm = async () =>{
        if (!password) {    
            setPasswordError("Password is required");
            return;
        }else{
        try {
            setLoading(true);
            const payload = {
                user_id: props.userId,
                id: currentToggleId,
                password: password,
                method:selectedMethod,
            };
            const response = await TwoFAService.delete2FA(payload);
            console.log(response);
            if (response && response.code === OK) {
                setShowDeleteModal(false);
                setConfirmDeleteModal(true);
                setPassword("")
            } else {
                setPasswordError('Invalid Password');
            }
        } catch (error) {
            console.error("Error deleting 2FA method:", error);
            alert("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    }
    };
    const handleDeleteVerify = async () =>{
        setLoading(true);
        if (!verificationCode){ 
            setVerificationCodeError('Verification code is required');
            return;
        }
        try {
            const response = await TwoFAService.destroy2FA({
                user_id: props.userId,
                id: currentToggleId,
                code: verificationCode,
                method:selectedMethod,
            });
            console.log(response);
            if (response && response.code === OK) {
                setEnabledMethods((prevMethods) =>
                    prevMethods.filter((method) => method.id !== currentToggleId)
                );
                setVerificationCode("")
                setConfirmDeleteModal(false);
                fetchEnabledMethods()
            } else {
                setVerificationCodeError('Verification code is Invalid');
            }
        } catch (error) {
            console.error("Error verifying 2FA:", error);
            alert("Failed to verify. Please try again.");
        } finally {
            setLoading(false);
        }
    }
    const toggleQRHandler = async (obj)=>{
        const payload = {
            user_id: props.userId,
            two_factor_method: obj.method
        };

        try {
            const response = await TwoFAService.enableTwoFA(payload);
            if (response) {
                setQrCode(response.qr_code);
            }
             setQrCodeModal(true)
        }catch(err){

        }
    }
    return (
        <>
        {
            isQrCodeModal ?
            <QRCodeGenerator
            qrCodeDetails={{ link: qrCode, clinicName: "MyApp" }}
            modleToogleHandler={()=>setQrCodeModal(!isQrCodeModal)}
            />
            :
            ''
        }
        <div className="d-flex">
            {/* Sidebar for enabled 2FA methods */}
            <div className="card p-4 shadow-lg me-4" style={{ maxWidth: "300px", width: "100%" }}>
                <h3>Enabled 2FA Methods</h3>
                <ul className="list-group">
                    {enabledMethods.length > 0 ? (
                        enabledMethods.map((list, index) => (
                            <li key={index} className="list-group-item d-flex ">
                                <div>{list.method}</div> 
                                <div className="form-check d-flex  ml-auto px-0">
                                <label class="switch">  
                                    <FormInputs  
                                    className="form-check-input"
                                        id={`checkbox_${index}`}
                                        type="Checkbox"
                                        value={list.enabled}
                                        readOnly={!list.enabled}
                                        changeHandler={() => handleToggle(list.id, list.enabled,list.method)}
                                        />
                                            <span class="slider"></span>
                                    </label>
                                    <div className="cursor-pointer" onClick={() => handleDelete(list.id,list.method)}
                                    >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" id="delete"><path fill="#f4493b" d="M24.2,12.193,23.8,24.3a3.988,3.988,0,0,1-4,3.857H12.2a3.988,3.988,0,0,1-4-3.853L7.8,12.193a1,1,0,0,1,2-.066l.4,12.11a2,2,0,0,0,2,1.923h7.6a2,2,0,0,0,2-1.927l.4-12.106a1,1,0,0,1,2,.066Zm1.323-4.029a1,1,0,0,1-1,1H7.478a1,1,0,0,1,0-2h3.1a1.276,1.276,0,0,0,1.273-1.148,2.991,2.991,0,0,1,2.984-2.694h2.33a2.991,2.991,0,0,1,2.984,2.694,1.276,1.276,0,0,0,1.273,1.148h3.1A1,1,0,0,1,25.522,8.164Zm-11.936-1h4.828a3.3,3.3,0,0,1-.255-.944,1,1,0,0,0-.994-.9h-2.33a1,1,0,0,0-.994.9A3.3,3.3,0,0,1,13.586,7.164Zm1.007,15.151V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Zm4.814,0V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Z"></path></svg>
                                      </div>
                                     </div>
                                <div>                           
                                    {/* Toggle Button */}
                                    {/* <button
                                        className={`btn btn-sm ${list.enabled ? "btn-success" : "btn-warning"} me-2`}
                                        onClick={() => handleToggle(list.id, list.enabled,list.method)}
                                        disabled={loading} // Disable while processing
                                    >
                                        {list.enabled ? "Enable" : "Disable"}
                                    </button>

                                    {/* Delete Button */}
                                    {/* <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleDelete(list.id,list.method)}
                                        disabled={loading} // Disable while processing
                                    >
                                        Delete
                                    </button> */} 
                                </div>
                            </li>
                        ))
                    ) : (
                        <li className="list-group-item">No 2FA methods enabled.</li>
                    )}
                </ul>
            </div>

            {/* Main content for adding or verifying 2FA */}
            <div className="card p-4 shadow-lg" style={{ width: "100%" }}>
            <div className="d-flex align-items-center w-100">  {showVerification && <div ><a onClick={()=>{setShowVerification(false); setIsTimerActive(false)}} className="badge back_btn cursor-pointer">Back</a>
                </div>}
                <h2 className="text-center w-100">Two-Factor Authentication</h2></div>
                {!showVerification ? (
                    <>
                        <p className="text-center ">
                            Protect your account with 2FA. How would you like to receive the one-time passwords?
                        </p>
                  
                        <form onSubmit={handleSubmit}>
                        {verifyData.length>0 && verifyData.map((item)=>{
                              return   <div 
                                className={`card mb-3 option-card ${selectedMethod === item.varName ? "border-primary" : ""}`} 
                                onClick={() => handleMethodSelect(item.varName)}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="card-body text-center">
                                    <h5 className="fw-bold">{item.head}</h5>
                                    <p className="text-muted mb-0">{item.para}</p>
                                </div>
                            </div>
                        })}
                          <div className="justify-content-center d-flex w-100">  
                            <button 
                                type="submit" 
                                className="btn btn-primary  w-25 mt-3" 
                                disabled={!selectedMethod || loading}
                            >
                                {loading ? "Processing..." : "Continue"}
                            </button>
                         </div>
                        </form>
                    </>
                ) : (
                    <>
                        {selectedMethod === "app" && qrCode && (
                            // <div className="mt-4 text-center">
                            //     <h5>Scan the QR Code</h5>
                            //     <img 
                            //         src={`https://chart.googleapis.com/chart?chs=200x200&cht=qr&chl=${encodeURIComponent(qrCode)}`} 
                            //         alt="QR Code" 
                            //         className="img-fluid"
                            //     />
                            //     <p className="mt-2">Secret Key: <strong>{secretKey}</strong></p>
                            //     <p className="text-center">
                            //         Enter the 6-digit code generated in your Authenticator app.
                            //     </p>
                            // </div>
                            <div className="text-center mb-3"><button className=" btn btn-outline-primary" onClick={()=>setQrCodeModal(true)}>Show the QR Code</button></div>
                        )}

                        <form onSubmit={handleVerify}>
                            {selectedMethod !== "app" && (
                                <p className="text-center">
                                    We have sent a verification code to your {selectedMethod}.
                                </p>
                            )}
                            <input
                                type="text"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                                className="form-control mb-3"
                                placeholder="Enter verification code"
                                value={verificationCode}
                                onChange={(e) => handleVerificationCode(e)}
                                required
                            />
                            {isError && <span className="text-danger">{isError}</span>}
                           <div className="d-flex justify-content-center align-items-center w-100"> <button type="submit" className="btn btn-primary w-25" disabled={loading}>
                                {loading ? "Verifying..." : "Verify Code"}
                            </button></div>
                        </form>
                        {isTimerActive && selectedMethod !== "app" && (
                            <div className="mt-3 text-center">
                                <p>Time remaining: {timer} seconds</p>
                            </div>
                        )}
                        {canResend && (
                            <div className="text-center mt-2">
                                <a href="#" onClick={handleResend}>Resend Code</a>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
        {/* Confirmation Modal for toggling 2FA method */}
        <Modal show={showModal} onHide={cancelToggle}
         dialogClassName="sh_modalConfirm"
        >
            <div class=" flex-column mx-auto">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    transform="scale(1)"
                    id="RtW2NldrkQ"
                    viewBox="0 0 500 500"
                    className="pbimage_pbimage__wrapper__image__0LEis false"
                    width="100px"
                    height="100px"
                    {...props}
                >
                    <title>{"Authentication 2"}</title>
                    <defs>
                    <style>
                        {
                        " .cls-1{fill:url(#linear-gradient-RtW2NldrkQ);} .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10{stroke-width:0px;} .cls-2{isolation:isolate;opacity:.18;} .cls-2, .cls-10{fill:#68e1fd;} .cls-3{fill:url(#linear-gradient-4-RtW2NldrkQ);} .cls-4{fill:url(#linear-gradient-2-RtW2NldrkQ);} .cls-5{fill:url(#linear-gradient-3-RtW2NldrkQ);} .cls-6{fill:url(#linear-gradient-5-RtW2NldrkQ);} .cls-7{fill:url(#linear-gradient-6-RtW2NldrkQ);} .cls-9{fill:#fff;}\n .cls-2, .cls-10{fill:#68E1FD;}\n .cls-9{fill:#FFFFFF;}"
                        }
                    </style>
                    <linearGradient
                        id="linear-gradient-RtW2NldrkQ"
                        x1={301.13}
                        y1={1412.54}
                        x2={299.48}
                        y2={1473.24}
                        gradientTransform="translate(-31 1810.33) scale(1 -1)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop
                        offset={0}
                        stopColor="#231f20"
                        stopOpacity={0}
                        style={{
                            stopColor: "rgb(35, 31, 32)",
                        }}
                        />
                        <stop
                        offset={1}
                        stopColor="#231f20"
                        style={{
                            stopColor: "rgb(35, 31, 32)",
                        }}
                        />
                    </linearGradient>
                    <linearGradient
                        id="linear-gradient-2-RtW2NldrkQ"
                        x1={301.94}
                        y1={1462.55}
                        x2={301.38}
                        y2={1396.35}
                        xlinkHref="#linear-gradient-RtW2NldrkQ"
                    />
                    <linearGradient
                        id="linear-gradient-3-RtW2NldrkQ"
                        x1={236.08}
                        y1={1618.97}
                        x2={277.22}
                        y2={1287.27}
                        xlinkHref="#linear-gradient-RtW2NldrkQ"
                    />
                    <linearGradient
                        id="linear-gradient-4-RtW2NldrkQ"
                        x1={273.49}
                        y1={1654.9}
                        x2={165.98}
                        y2={1587.19}
                        xlinkHref="#linear-gradient-RtW2NldrkQ"
                    />
                    <linearGradient
                        id="linear-gradient-5-RtW2NldrkQ"
                        x1={267.94}
                        y1={1647.01}
                        x2={185.78}
                        y2={1595.26}
                        xlinkHref="#linear-gradient-RtW2NldrkQ"
                    />
                    <linearGradient
                        id="linear-gradient-6-RtW2NldrkQ"
                        x1={222.45}
                        y1={1584.17}
                        x2={222.09}
                        y2={1600.2}
                        gradientTransform="translate(-32.99 1785.78) scale(1 -1)"
                        xlinkHref="#linear-gradient-RtW2NldrkQ"
                    />
                    </defs>
                    <path
                    className="cls-2"
                    id="background"
                    d="M465.54,173.8c-20.03-22.76-45.7-39.69-71.09-56.34-30.68-20.16-62.71-40.85-99.05-45.84-34.72-4.78-70.17,5.45-100.93,22.25-30.77,16.79-57.56,39.87-84.11,62.75l-62.5,53.91c-13.15,11.34-26.66,23.14-34.14,38.81-6.35,13.28-7.85,28.48-6.64,43.12,2.96,33.69,19.36,64.78,45.51,86.24,18.16,14.72,40.05,24.01,61.83,32.56,40.02,15.66,81.27,29.48,124.07,33.33,45.7,4.11,91.57-3.29,136.86-10.66,55.61-9.05,87.52-32.7,96.72-87.48,5-29.65,21.21-56.51,24.61-86.24,3.69-32.01-10.43-62.81-31.14-86.39Z"
                    />
                    <g id="laptop">
                    <rect
                        className="cls-10"
                        x={89.22}
                        y={108.77}
                        width={369.16}
                        height={260.87}
                        rx={15.64}
                        ry={15.64}
                    />
                    <rect
                        className="cls-9"
                        x={101.79}
                        y={117.64}
                        width={344.09}
                        height={239.43}
                        rx={14.46}
                        ry={14.46}
                        fill="#FFFFFF"
                    />
                    <rect
                        className="cls-10"
                        x={59.69}
                        y={367.19}
                        width={420.01}
                        height={29.53}
                        rx={14.01}
                        ry={14.01}
                    />
                    <rect
                        className="cls-1"
                        x={59.69}
                        y={367.19}
                        width={420.01}
                        height={29.53}
                        rx={14.01}
                        ry={14.01}
                    />
                    <rect
                        className="cls-4"
                        x={228.13}
                        y={367.46}
                        width={85.21}
                        height={8.75}
                    />
                    </g>
                    <g id="password">
                    <polygon
                        className="cls-5"
                        points="318.1 328.63 263.95 301.55 90.32 301.55 90.32 239.05 339.43 239.05 317.28 283.78 318.1 328.63"
                    />
                    <path
                        className="cls-10"
                        d="M339.43,148.65v122.02c0,8.88-7.19,16.09-16.07,16.12H74.97c-8.88,0-16.08-7.2-16.08-16.08,0-.01,0-.02,0-.03v-122.02c0-8.88,7.2-16.08,16.08-16.08h248.39c8.87.02,16.06,7.21,16.07,16.08Z"
                    />
                    <path
                        className="cls-9"
                        d="M198.92,163.86c-1.5.54-3.17-.21-3.76-1.69l-2.82-7.49c-1.69-4.3-6.55-6.41-10.85-4.72-4.22,1.66-6.35,6.38-4.8,10.64l3.9,10.31c.06.17.11.35.14.52h-6.18l-3.32-8.78c-2.65-7.38,1.19-15.51,8.57-18.15,7.2-2.58,15.15,1,17.98,8.11l2.83,7.48c.57,1.5-.18,3.19-1.68,3.76,0,0,0,0,0,0Z"
                    />
                    <polygon
                        className="cls-10"
                        points="268.87 285.97 318.1 328.63 318.1 276.53 268.87 285.97"
                    />
                    <rect
                        className="cls-9"
                        x={95.23}
                        y={219.25}
                        width={204.54}
                        height={35.01}
                        rx={7.21}
                        ry={7.21}
                    />
                    <rect
                        className="cls-3"
                        x={169.75}
                        y={171.5}
                        width={38.28}
                        height={35.37}
                    />
                    <rect
                        className="cls-6"
                        x={183.98}
                        y={171.43}
                        width={24.01}
                        height={35.37}
                    />
                    <path
                        className="cls-7"
                        d="M187.97,188s-3.78-3.15-.48-5.83,6.99,2.91,3.5,5.83l2.46,6.56h-8.3l2.82-6.56Z"
                    />
                    <circle className="cls-8" cx={124.52} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={144.23} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={163.93} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={183.64} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={204.89} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={224.6} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={244.31} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={264.02} cy={235.93} r={7.31} />
                    <path
                        className="cls-10"
                        d="M68.71,121.16c-2.32,0-4.41-1.37-5.34-3.5l-12.59-28.99c-1.29-2.95.06-6.39,3.02-7.68,2.95-1.29,6.39.06,7.68,3.02l12.57,29.01c1.29,2.95-.06,6.38-3.01,7.67-.74.32-1.53.49-2.34.49h0Z"
                    />
                    <path
                        className="cls-10"
                        d="M12.21,160.91c-3.22.11-5.91-2.42-6.02-5.63-.11-3.22,2.42-5.91,5.63-6.02l31.52-2.11c3.22-.22,6,2.22,6.22,5.44s-2.22,6-5.44,6.22l-31.53,2.1h-.38Z"
                    />
                    <path
                        className="cls-10"
                        d="M45.74,132.23c-1.15,0-2.28-.35-3.23-1l-26.19-17.76c-2.63-1.85-3.27-5.48-1.42-8.12,1.81-2.58,5.34-3.25,7.97-1.52l26.14,17.76c2.66,1.81,3.34,5.44,1.53,8.1-1.08,1.59-2.88,2.54-4.8,2.54Z"
                    />
                    </g>
                </svg>
            </div>
            <Modal.Body>
                {currentToggleState ? (
                    // When currentToggleState is true (disabling 2FA)
                    <>
                     <h4 class="modal-title w-100">Confirm 2FA Disable</h4>
                        <p className="mb-1">
                            Are you sure you want to disable {enabledMethods.find(method => method.id === currentToggleId)?.method}?
                        </p>
                        {/* Password input field */}
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label">Enter your password to confirm</label>
                            <input
                                type="password"
                                id="password"
                                className="form-control"
                                value={password}
                                onChange={handlePasswordChange}
                                placeholder="Enter your password"
                                required
                            />
                            {passwordError && <div className="text-danger mt-2">{passwordError}</div>}
                        </div>
                    </>
                ) : (
                    // When currentToggleState is false (enabling 2FA)
                    <p>
                        For enabling two-factor authentication, use the Authenticator.
                    </p>
                )}
            </Modal.Body>
            <Modal.Footer  className="justify-content-between pt-0">
                <button className="btn btn-outline-secondary" onClick={cancelToggle}>
                    Cancel
                </button>
                {currentToggleState && (
                    <button
                        className="btn btn-primary"
                        onClick={handleConfirm}
                        disabled={loading} // Disable the button while loading
                    >
                        {loading ? 'Processing...' : 'Confirm'}
                    </button>
                )}
            </Modal.Footer>
        </Modal>
        <Modal show={showDeleteModel} onHide={cancelDeleteToggle}
         dialogClassName="sh_modalConfirm"
        >
        <div class=" flex-column mx-auto">
           <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            transform="scale(1)"
            id="RtW2NldrkQ"
            viewBox="0 0 500 500"
            className="pbimage_pbimage__wrapper__image__0LEis false"
            width="100px"
            height="100px"
            {...props}
        >
            <title>{"Authentication 2"}</title>
            <defs>
            <style>
                {
                " .cls-1{fill:url(#linear-gradient-RtW2NldrkQ);} .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10{stroke-width:0px;} .cls-2{isolation:isolate;opacity:.18;} .cls-2, .cls-10{fill:#68e1fd;} .cls-3{fill:url(#linear-gradient-4-RtW2NldrkQ);} .cls-4{fill:url(#linear-gradient-2-RtW2NldrkQ);} .cls-5{fill:url(#linear-gradient-3-RtW2NldrkQ);} .cls-6{fill:url(#linear-gradient-5-RtW2NldrkQ);} .cls-7{fill:url(#linear-gradient-6-RtW2NldrkQ);} .cls-9{fill:#fff;}\n .cls-2, .cls-10{fill:#68E1FD;}\n .cls-9{fill:#FFFFFF;}"
                }
            </style>
            <linearGradient
                id="linear-gradient-RtW2NldrkQ"
                x1={301.13}
                y1={1412.54}
                x2={299.48}
                y2={1473.24}
                gradientTransform="translate(-31 1810.33) scale(1 -1)"
                gradientUnits="userSpaceOnUse"
            >
                <stop
                offset={0}
                stopColor="#231f20"
                stopOpacity={0}
                style={{
                    stopColor: "rgb(35, 31, 32)",
                }}
                />
                <stop
                offset={1}
                stopColor="#231f20"
                style={{
                    stopColor: "rgb(35, 31, 32)",
                }}
                />
            </linearGradient>
            <linearGradient
                id="linear-gradient-2-RtW2NldrkQ"
                x1={301.94}
                y1={1462.55}
                x2={301.38}
                y2={1396.35}
                xlinkHref="#linear-gradient-RtW2NldrkQ"
            />
            <linearGradient
                id="linear-gradient-3-RtW2NldrkQ"
                x1={236.08}
                y1={1618.97}
                x2={277.22}
                y2={1287.27}
                xlinkHref="#linear-gradient-RtW2NldrkQ"
            />
            <linearGradient
                id="linear-gradient-4-RtW2NldrkQ"
                x1={273.49}
                y1={1654.9}
                x2={165.98}
                y2={1587.19}
                xlinkHref="#linear-gradient-RtW2NldrkQ"
            />
            <linearGradient
                id="linear-gradient-5-RtW2NldrkQ"
                x1={267.94}
                y1={1647.01}
                x2={185.78}
                y2={1595.26}
                xlinkHref="#linear-gradient-RtW2NldrkQ"
            />
            <linearGradient
                id="linear-gradient-6-RtW2NldrkQ"
                x1={222.45}
                y1={1584.17}
                x2={222.09}
                y2={1600.2}
                gradientTransform="translate(-32.99 1785.78) scale(1 -1)"
                xlinkHref="#linear-gradient-RtW2NldrkQ"
            />
            </defs>
            <path
            className="cls-2"
            id="background"
            d="M465.54,173.8c-20.03-22.76-45.7-39.69-71.09-56.34-30.68-20.16-62.71-40.85-99.05-45.84-34.72-4.78-70.17,5.45-100.93,22.25-30.77,16.79-57.56,39.87-84.11,62.75l-62.5,53.91c-13.15,11.34-26.66,23.14-34.14,38.81-6.35,13.28-7.85,28.48-6.64,43.12,2.96,33.69,19.36,64.78,45.51,86.24,18.16,14.72,40.05,24.01,61.83,32.56,40.02,15.66,81.27,29.48,124.07,33.33,45.7,4.11,91.57-3.29,136.86-10.66,55.61-9.05,87.52-32.7,96.72-87.48,5-29.65,21.21-56.51,24.61-86.24,3.69-32.01-10.43-62.81-31.14-86.39Z"
            />
            <g id="laptop">
            <rect
                className="cls-10"
                x={89.22}
                y={108.77}
                width={369.16}
                height={260.87}
                rx={15.64}
                ry={15.64}
            />
            <rect
                className="cls-9"
                x={101.79}
                y={117.64}
                width={344.09}
                height={239.43}
                rx={14.46}
                ry={14.46}
                fill="#FFFFFF"
            />
            <rect
                className="cls-10"
                x={59.69}
                y={367.19}
                width={420.01}
                height={29.53}
                rx={14.01}
                ry={14.01}
            />
            <rect
                className="cls-1"
                x={59.69}
                y={367.19}
                width={420.01}
                height={29.53}
                rx={14.01}
                ry={14.01}
            />
            <rect
                className="cls-4"
                x={228.13}
                y={367.46}
                width={85.21}
                height={8.75}
            />
            </g>
            <g id="password">
            <polygon
                className="cls-5"
                points="318.1 328.63 263.95 301.55 90.32 301.55 90.32 239.05 339.43 239.05 317.28 283.78 318.1 328.63"
            />
            <path
                className="cls-10"
                d="M339.43,148.65v122.02c0,8.88-7.19,16.09-16.07,16.12H74.97c-8.88,0-16.08-7.2-16.08-16.08,0-.01,0-.02,0-.03v-122.02c0-8.88,7.2-16.08,16.08-16.08h248.39c8.87.02,16.06,7.21,16.07,16.08Z"
            />
            <path
                className="cls-9"
                d="M198.92,163.86c-1.5.54-3.17-.21-3.76-1.69l-2.82-7.49c-1.69-4.3-6.55-6.41-10.85-4.72-4.22,1.66-6.35,6.38-4.8,10.64l3.9,10.31c.06.17.11.35.14.52h-6.18l-3.32-8.78c-2.65-7.38,1.19-15.51,8.57-18.15,7.2-2.58,15.15,1,17.98,8.11l2.83,7.48c.57,1.5-.18,3.19-1.68,3.76,0,0,0,0,0,0Z"
            />
            <polygon
                className="cls-10"
                points="268.87 285.97 318.1 328.63 318.1 276.53 268.87 285.97"
            />
            <rect
                className="cls-9"
                x={95.23}
                y={219.25}
                width={204.54}
                height={35.01}
                rx={7.21}
                ry={7.21}
            />
            <rect
                className="cls-3"
                x={169.75}
                y={171.5}
                width={38.28}
                height={35.37}
            />
            <rect
                className="cls-6"
                x={183.98}
                y={171.43}
                width={24.01}
                height={35.37}
            />
            <path
                className="cls-7"
                d="M187.97,188s-3.78-3.15-.48-5.83,6.99,2.91,3.5,5.83l2.46,6.56h-8.3l2.82-6.56Z"
            />
            <circle className="cls-8" cx={124.52} cy={235.93} r={7.31} />
            <circle className="cls-8" cx={144.23} cy={235.93} r={7.31} />
            <circle className="cls-8" cx={163.93} cy={235.93} r={7.31} />
            <circle className="cls-8" cx={183.64} cy={235.93} r={7.31} />
            <circle className="cls-8" cx={204.89} cy={235.93} r={7.31} />
            <circle className="cls-8" cx={224.6} cy={235.93} r={7.31} />
            <circle className="cls-8" cx={244.31} cy={235.93} r={7.31} />
            <circle className="cls-8" cx={264.02} cy={235.93} r={7.31} />
            <path
                className="cls-10"
                d="M68.71,121.16c-2.32,0-4.41-1.37-5.34-3.5l-12.59-28.99c-1.29-2.95.06-6.39,3.02-7.68,2.95-1.29,6.39.06,7.68,3.02l12.57,29.01c1.29,2.95-.06,6.38-3.01,7.67-.74.32-1.53.49-2.34.49h0Z"
            />
            <path
                className="cls-10"
                d="M12.21,160.91c-3.22.11-5.91-2.42-6.02-5.63-.11-3.22,2.42-5.91,5.63-6.02l31.52-2.11c3.22-.22,6,2.22,6.22,5.44s-2.22,6-5.44,6.22l-31.53,2.1h-.38Z"
            />
            <path
                className="cls-10"
                d="M45.74,132.23c-1.15,0-2.28-.35-3.23-1l-26.19-17.76c-2.63-1.85-3.27-5.48-1.42-8.12,1.81-2.58,5.34-3.25,7.97-1.52l26.14,17.76c2.66,1.81,3.34,5.44,1.53,8.1-1.08,1.59-2.88,2.54-4.8,2.54Z"
            />
            </g>
        </svg>
        </div>
            <Modal.Body>
                    <>
                    <h4 class="modal-title w-100">Confirm 2FA Delete</h4>
                        <p className="mb-1">
                            Are you sure you want to Delete {enabledMethods.find(method => method.id === currentToggleId)?.method} Authenticator ?
                        </p>
                        {/* Password input field */}
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label">Enter your password to confirm</label>
                            <input
                                type="password"
                                id="password"
                                className="form-control"
                                value={password}
                                onChange={handlePasswordChange}
                                placeholder="Enter your password"
                                required
                            />
                            {passwordError && <div className="text-danger mt-2">{passwordError}</div>}
                        </div>
                    </>
            </Modal.Body>
            <Modal.Footer className="justify-content-between pt-0">
                <button className="btn btn-outline-secondary" onClick={cancelDeleteToggle}>
                    Cancel
                </button>
                    <button
                        className="btn btn-primary"
                        onClick={handleDeleteConfirm}
                        disabled={loading} // Disable the button while loading
                    >
                        {loading ? 'Processing...' : 'Confirm'}
                    </button>
            </Modal.Footer>
        </Modal>
        <Modal show={showConfirmDeleteModal} onHide={closeDeleteModal}
        dialogClassName="sh_modalConfirm"
        >
            <div class=" flex-column mx-auto">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    transform="scale(1)"
                    id="RtW2NldrkQ"
                    viewBox="0 0 500 500"
                    className="pbimage_pbimage__wrapper__image__0LEis false"
                    width="100px"
                    height="100px"
                    {...props}
                >
                    <title>{"Authentication 2"}</title>
                    <defs>
                    <style>
                        {
                        " .cls-1{fill:url(#linear-gradient-RtW2NldrkQ);} .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10{stroke-width:0px;} .cls-2{isolation:isolate;opacity:.18;} .cls-2, .cls-10{fill:#68e1fd;} .cls-3{fill:url(#linear-gradient-4-RtW2NldrkQ);} .cls-4{fill:url(#linear-gradient-2-RtW2NldrkQ);} .cls-5{fill:url(#linear-gradient-3-RtW2NldrkQ);} .cls-6{fill:url(#linear-gradient-5-RtW2NldrkQ);} .cls-7{fill:url(#linear-gradient-6-RtW2NldrkQ);} .cls-9{fill:#fff;}\n .cls-2, .cls-10{fill:#68E1FD;}\n .cls-9{fill:#FFFFFF;}"
                        }
                    </style>
                    <linearGradient
                        id="linear-gradient-RtW2NldrkQ"
                        x1={301.13}
                        y1={1412.54}
                        x2={299.48}
                        y2={1473.24}
                        gradientTransform="translate(-31 1810.33) scale(1 -1)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop
                        offset={0}
                        stopColor="#231f20"
                        stopOpacity={0}
                        style={{
                            stopColor: "rgb(35, 31, 32)",
                        }}
                        />
                        <stop
                        offset={1}
                        stopColor="#231f20"
                        style={{
                            stopColor: "rgb(35, 31, 32)",
                        }}
                        />
                    </linearGradient>
                    <linearGradient
                        id="linear-gradient-2-RtW2NldrkQ"
                        x1={301.94}
                        y1={1462.55}
                        x2={301.38}
                        y2={1396.35}
                        xlinkHref="#linear-gradient-RtW2NldrkQ"
                    />
                    <linearGradient
                        id="linear-gradient-3-RtW2NldrkQ"
                        x1={236.08}
                        y1={1618.97}
                        x2={277.22}
                        y2={1287.27}
                        xlinkHref="#linear-gradient-RtW2NldrkQ"
                    />
                    <linearGradient
                        id="linear-gradient-4-RtW2NldrkQ"
                        x1={273.49}
                        y1={1654.9}
                        x2={165.98}
                        y2={1587.19}
                        xlinkHref="#linear-gradient-RtW2NldrkQ"
                    />
                    <linearGradient
                        id="linear-gradient-5-RtW2NldrkQ"
                        x1={267.94}
                        y1={1647.01}
                        x2={185.78}
                        y2={1595.26}
                        xlinkHref="#linear-gradient-RtW2NldrkQ"
                    />
                    <linearGradient
                        id="linear-gradient-6-RtW2NldrkQ"
                        x1={222.45}
                        y1={1584.17}
                        x2={222.09}
                        y2={1600.2}
                        gradientTransform="translate(-32.99 1785.78) scale(1 -1)"
                        xlinkHref="#linear-gradient-RtW2NldrkQ"
                    />
                    </defs>
                    <path
                    className="cls-2"
                    id="background"
                    d="M465.54,173.8c-20.03-22.76-45.7-39.69-71.09-56.34-30.68-20.16-62.71-40.85-99.05-45.84-34.72-4.78-70.17,5.45-100.93,22.25-30.77,16.79-57.56,39.87-84.11,62.75l-62.5,53.91c-13.15,11.34-26.66,23.14-34.14,38.81-6.35,13.28-7.85,28.48-6.64,43.12,2.96,33.69,19.36,64.78,45.51,86.24,18.16,14.72,40.05,24.01,61.83,32.56,40.02,15.66,81.27,29.48,124.07,33.33,45.7,4.11,91.57-3.29,136.86-10.66,55.61-9.05,87.52-32.7,96.72-87.48,5-29.65,21.21-56.51,24.61-86.24,3.69-32.01-10.43-62.81-31.14-86.39Z"
                    />
                    <g id="laptop">
                    <rect
                        className="cls-10"
                        x={89.22}
                        y={108.77}
                        width={369.16}
                        height={260.87}
                        rx={15.64}
                        ry={15.64}
                    />
                    <rect
                        className="cls-9"
                        x={101.79}
                        y={117.64}
                        width={344.09}
                        height={239.43}
                        rx={14.46}
                        ry={14.46}
                        fill="#FFFFFF"
                    />
                    <rect
                        className="cls-10"
                        x={59.69}
                        y={367.19}
                        width={420.01}
                        height={29.53}
                        rx={14.01}
                        ry={14.01}
                    />
                    <rect
                        className="cls-1"
                        x={59.69}
                        y={367.19}
                        width={420.01}
                        height={29.53}
                        rx={14.01}
                        ry={14.01}
                    />
                    <rect
                        className="cls-4"
                        x={228.13}
                        y={367.46}
                        width={85.21}
                        height={8.75}
                    />
                    </g>
                    <g id="password">
                    <polygon
                        className="cls-5"
                        points="318.1 328.63 263.95 301.55 90.32 301.55 90.32 239.05 339.43 239.05 317.28 283.78 318.1 328.63"
                    />
                    <path
                        className="cls-10"
                        d="M339.43,148.65v122.02c0,8.88-7.19,16.09-16.07,16.12H74.97c-8.88,0-16.08-7.2-16.08-16.08,0-.01,0-.02,0-.03v-122.02c0-8.88,7.2-16.08,16.08-16.08h248.39c8.87.02,16.06,7.21,16.07,16.08Z"
                    />
                    <path
                        className="cls-9"
                        d="M198.92,163.86c-1.5.54-3.17-.21-3.76-1.69l-2.82-7.49c-1.69-4.3-6.55-6.41-10.85-4.72-4.22,1.66-6.35,6.38-4.8,10.64l3.9,10.31c.06.17.11.35.14.52h-6.18l-3.32-8.78c-2.65-7.38,1.19-15.51,8.57-18.15,7.2-2.58,15.15,1,17.98,8.11l2.83,7.48c.57,1.5-.18,3.19-1.68,3.76,0,0,0,0,0,0Z"
                    />
                    <polygon
                        className="cls-10"
                        points="268.87 285.97 318.1 328.63 318.1 276.53 268.87 285.97"
                    />
                    <rect
                        className="cls-9"
                        x={95.23}
                        y={219.25}
                        width={204.54}
                        height={35.01}
                        rx={7.21}
                        ry={7.21}
                    />
                    <rect
                        className="cls-3"
                        x={169.75}
                        y={171.5}
                        width={38.28}
                        height={35.37}
                    />
                    <rect
                        className="cls-6"
                        x={183.98}
                        y={171.43}
                        width={24.01}
                        height={35.37}
                    />
                    <path
                        className="cls-7"
                        d="M187.97,188s-3.78-3.15-.48-5.83,6.99,2.91,3.5,5.83l2.46,6.56h-8.3l2.82-6.56Z"
                    />
                    <circle className="cls-8" cx={124.52} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={144.23} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={163.93} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={183.64} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={204.89} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={224.6} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={244.31} cy={235.93} r={7.31} />
                    <circle className="cls-8" cx={264.02} cy={235.93} r={7.31} />
                    <path
                        className="cls-10"
                        d="M68.71,121.16c-2.32,0-4.41-1.37-5.34-3.5l-12.59-28.99c-1.29-2.95.06-6.39,3.02-7.68,2.95-1.29,6.39.06,7.68,3.02l12.57,29.01c1.29,2.95-.06,6.38-3.01,7.67-.74.32-1.53.49-2.34.49h0Z"
                    />
                    <path
                        className="cls-10"
                        d="M12.21,160.91c-3.22.11-5.91-2.42-6.02-5.63-.11-3.22,2.42-5.91,5.63-6.02l31.52-2.11c3.22-.22,6,2.22,6.22,5.44s-2.22,6-5.44,6.22l-31.53,2.1h-.38Z"
                    />
                    <path
                        className="cls-10"
                        d="M45.74,132.23c-1.15,0-2.28-.35-3.23-1l-26.19-17.76c-2.63-1.85-3.27-5.48-1.42-8.12,1.81-2.58,5.34-3.25,7.97-1.52l26.14,17.76c2.66,1.81,3.34,5.44,1.53,8.1-1.08,1.59-2.88,2.54-4.8,2.54Z"
                    />
                    </g>
                </svg>
            </div>
            <Modal.Body>
                    <>
                    <h4 class="modal-title w-100">Confirm 2FA Delete</h4>
                        <p className="mb-0">
                            Are you sure you want to Delete {enabledMethods.find(method => method.id === currentToggleId)?.method} Authenticator ?
                        </p>
                        {enabledMethods.find(method => method.id === currentToggleId)?.method === 'app' && 
                            <div className="text-center mb-3"><button className=" btn  btn-outline-primary" onClick={()=>toggleQRHandler(enabledMethods.find(method => method.id === currentToggleId))}>Show the QR Code</button>
                                </div>}
                        {/* Password input field */}
                        <div className="mb-3">
                            <label className="form-label">Enter verification code to confirm</label>
                            <input
                                id="verificationCode"
                                className="form-control"
                                value={verificationCode}
                                onChange={(e) => setVerificationCode(e.target.value)}
                                placeholder="Enter your verification code"
                                required
                            />
                            {verificationCodeErr && <div className="text-danger mt-2">{verificationCodeErr}</div>}
                        </div>
                    </>
            </Modal.Body>
            <Modal.Footer className="justify-content-between pt-0">
                <button className="btn btn-outline-secondary" onClick={cancelDeleteToggle}>
                    Cancel
                </button>
                    <button
                        className="btn btn-primary"
                        onClick={handleDeleteVerify}
                        disabled={loading} // Disable the button while loading
                    >
                        {loading ? 'Processing...' : 'Confirm'}
                    </button>
            </Modal.Footer>
        </Modal>
        </>
    );
};

export default WithRoutify(TwoFAVerify);